var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 249.998,
    height: 131.235,
    viewBox: "0 0 249.998 131.235",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #3b86ff;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #d1d3d4;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #e6e7e8;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10193",
    "data-name": "Group 10193",
    transform: "translate(21803 1535)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_595",
    "data-name": "Rectangle 595",
    className: "cls-1",
    width: 41.525,
    height: 8.814,
    transform: "matrix(0.883, -0.47, 0.47, 0.883, -21698.045, -1438.294)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_596",
    "data-name": "Rectangle 596",
    className: "cls-1",
    width: 10.577,
    height: 14.168,
    transform: "matrix(0.883, -0.47, 0.47, 0.883, -21662.578, -1460.145)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_597",
    "data-name": "Rectangle 597",
    className: "cls-1",
    width: 25.659,
    height: 5.289,
    transform: "matrix(0.883, -0.47, 0.47, 0.883, -21719.9, -1424.717)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_600",
    "data-name": "Rectangle 600",
    className: "cls-1",
    width: 21.22,
    height: 4.44,
    transform: "matrix(0.883, -0.47, 0.47, 0.883, -21697.551, -1448.596)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_229",
    "data-name": "Group 229",
    transform: "translate(-21721.646 -1466.901)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_395",
    "data-name": "Path 395",
    className: "cls-2",
    d: "M163.454,146.383l-5.354-10.12L197.079,115.5l5.354,10.12Zm-1.893-9.075,2.938,5.484,34.408-18.282-2.938-5.484Z",
    transform: "translate(-136.227 -108.187)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_396",
    "data-name": "Path 396",
    className: "cls-2",
    d: "M220.235,125.324,212.4,110.5l11.687-6.2,7.835,14.821Zm-4.374-13.711L221.28,121.8l7.051-3.787-5.419-10.185Z",
    transform: "translate(-155.074 -104.3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_397",
    "data-name": "Path 397",
    className: "cls-2",
    d: "M128.322,168.04l-3.722-6.986L149.541,147.8l3.722,6.986Zm-.2-5.876,1.241,2.35,20.306-10.838-1.241-2.35Z",
    transform: "translate(-124.6 -119.398)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20",
    transform: "translate(34.433 16.607)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_598",
    "data-name": "Rectangle 598",
    className: "cls-2",
    width: 2.612,
    height: 4.44,
    transform: "matrix(0.883, -0.47, 0.47, 0.883, 0, 1.226)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21",
    transform: "translate(26.615 20.796)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_599",
    "data-name": "Rectangle 599",
    className: "cls-2",
    width: 2.612,
    height: 4.44,
    transform: "matrix(0.883, -0.47, 0.47, 0.883, 0, 1.226)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_398",
    "data-name": "Path 398",
    className: "cls-2",
    d: "M162.13,131.767l-3.33-6.2L179.824,114.4l3.33,6.2Zm.261-5.093.849,1.567,16.453-8.749-.849-1.567Z",
    transform: "translate(-136.47 -107.806)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23",
    transform: "translate(0.588 36.955)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_399",
    "data-name": "Path 399",
    className: "cls-2",
    d: "M129.287,166.254l-1.306-2.481-2.481-.261.261-2.612,3.852.392,1.959,3.722Z",
    transform: "translate(-125.5 -160.9)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24",
    transform: "translate(29.252 31.406)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_601",
    "data-name": "Rectangle 601",
    className: "cls-2",
    width: 2.612,
    height: 2.677,
    transform: "translate(0 1.226) rotate(-27.995)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    "data-name": "Group 25",
    transform: "translate(35.506 28.07)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_602",
    "data-name": "Rectangle 602",
    className: "cls-2",
    width: 2.612,
    height: 2.677,
    transform: "matrix(0.883, -0.47, 0.47, 0.883, 0, 1.226)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26",
    transform: "translate(41.768 24.721)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_603",
    "data-name": "Rectangle 603",
    className: "cls-2",
    width: 2.612,
    height: 2.677,
    transform: "matrix(0.883, -0.47, 0.47, 0.883, 0, 1.226)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27",
    transform: "translate(47.97 21.422)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_604",
    "data-name": "Rectangle 604",
    className: "cls-2",
    width: 2.612,
    height: 2.677,
    transform: "matrix(0.883, -0.47, 0.47, 0.883, 0, 1.226)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28",
    transform: "translate(54.231 18.077)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_605",
    "data-name": "Rectangle 605",
    className: "cls-2",
    width: 2.612,
    height: 2.677,
    transform: "matrix(0.883, -0.47, 0.47, 0.883, 0, 1.226)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29",
    transform: "translate(60.434 14.764)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_606",
    "data-name": "Rectangle 606",
    className: "cls-2",
    width: 2.612,
    height: 2.677,
    transform: "matrix(0.883, -0.47, 0.47, 0.883, 0, 1.226)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30",
    transform: "translate(31.274 21.546)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_400",
    "data-name": "Path 400",
    className: "cls-2",
    d: "M175.177,155.32l-2.677-5.027,2.285-1.241,1.5,2.742,13.385-7.117L194.5,137.3l2.22,1.436L191.5,146.7Z",
    transform: "translate(-172.5 -137.3)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31",
    transform: "translate(28.586 32.746)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_607",
    "data-name": "Rectangle 607",
    className: "cls-2",
    width: 31.144,
    height: 2.612,
    transform: "translate(0 28.3) rotate(-65.324)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    transform: "translate(42.057 32.752)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_608",
    "data-name": "Rectangle 608",
    className: "cls-2",
    width: 2.612,
    height: 31.144,
    transform: "translate(0 1.09) rotate(-24.671)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    transform: "translate(41.721 33.298)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_609",
    "data-name": "Rectangle 609",
    className: "cls-2",
    width: 2.612,
    height: 29.185
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34",
    transform: "translate(60.462 8.216)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_610",
    "data-name": "Rectangle 610",
    className: "cls-2",
    width: 2.677,
    height: 2.612,
    transform: "translate(0 1.256) rotate(-27.982)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35",
    transform: "translate(62.99 12.909)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_611",
    "data-name": "Rectangle 611",
    className: "cls-2",
    width: 2.677,
    height: 2.612,
    transform: "translate(0 1.256) rotate(-27.982)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36",
    transform: "translate(67.474 0.726)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_612",
    "data-name": "Rectangle 612",
    className: "cls-2",
    width: 4.375,
    height: 13.189,
    transform: "matrix(0.883, -0.47, 0.47, 0.883, 0, 2.054)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37",
    transform: "translate(38.195 28.467)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    className: "cls-2",
    cx: 3.526,
    cy: 3.526,
    r: 3.526,
    transform: "translate(1.306 1.306)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_401",
    "data-name": "Path 401",
    className: "cls-2",
    d: "M187.932,157.563a4.832,4.832,0,1,1,4.832-4.832A4.821,4.821,0,0,1,187.932,157.563Zm0-7.051a2.22,2.22,0,1,0,2.22,2.22A2.2,2.2,0,0,0,187.932,150.512Z",
    transform: "translate(-183.1 -147.9)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    "data-name": "Group 38",
    transform: "translate(37.18 10.149)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_613",
    "data-name": "Rectangle 613",
    className: "cls-2",
    width: 2.612,
    height: 4.44,
    transform: "matrix(0.883, -0.47, 0.47, 0.883, 0, 1.226)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    "data-name": "Group 39",
    transform: "translate(5.186 39.188)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_614",
    "data-name": "Rectangle 614",
    className: "cls-2",
    width: 2.612,
    height: 5.289,
    transform: "matrix(0.883, -0.47, 0.47, 0.883, 0, 1.226)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_228",
    "data-name": "Group 228",
    transform: "translate(-21803 -1535)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42",
    "data-name": "Group 42",
    transform: "translate(0 49.164)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_419",
    "data-name": "Path 419",
    className: "cls-3",
    d: "M113.215,101.351a1.273,1.273,0,0,1-1.241-.914,7.835,7.835,0,0,0-6.921-5.55,1.422,1.422,0,0,1-1.175-.914,12.735,12.735,0,0,0-21.22-5.158,1.243,1.243,0,0,1-1.241.326,1.293,1.293,0,0,1-.914-.914,14.041,14.041,0,0,0-27.226.457,1.246,1.246,0,0,1-1.436.979,4.625,4.625,0,0,0-.914-.065A6.923,6.923,0,0,0,46.1,91.492a1.408,1.408,0,0,1-1.241.326,6.363,6.363,0,0,0-5.615,1.045,1.141,1.141,0,0,1-1.11.2,1.274,1.274,0,0,1-.849-.783,8.472,8.472,0,0,0-16.323,3.2,8.554,8.554,0,0,0,.979,3.983,1.367,1.367,0,0,1-1.175,1.959H1.306a1.306,1.306,0,1,1,0-2.612H18.8A11.076,11.076,0,0,1,38.979,89.99a9.006,9.006,0,0,1,5.876-.783,10.074,10.074,0,0,1,6.2-2.155A16.651,16.651,0,0,1,82.4,85.681a15.376,15.376,0,0,1,23.766,6.725,10.455,10.455,0,0,1,8.357,7.313,1.321,1.321,0,0,1-.849,1.632A1.067,1.067,0,0,0,113.215,101.351Z",
    transform: "translate(0 -75.3)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_51",
    "data-name": "Group 51",
    transform: "translate(168.418 34.115)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_43",
    "data-name": "Group 43"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_420",
    "data-name": "Path 420",
    className: "cls-3",
    d: "M273.652,83.557a15.645,15.645,0,1,1,11.034-26.7h0a15.637,15.637,0,0,1-11.034,26.7Zm0-28.728a12.944,12.944,0,0,0-9.206,3.787,13.065,13.065,0,1,0,18.477,0h0A13.2,13.2,0,0,0,273.652,54.829Z",
    transform: "translate(-257.95 -52.25)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_44",
    "data-name": "Group 44",
    transform: "translate(12.177 19.489)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    className: "cls-3",
    cx: 2.612,
    cy: 2.612,
    r: 2.612
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_45",
    "data-name": "Group 45",
    transform: "translate(4.603 4.538)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_421",
    "data-name": "Path 421",
    className: "cls-3",
    d: "M265,79.506l1.828,1.828,4.374-4.375a4.115,4.115,0,0,1,1.11-3,3.782,3.782,0,0,1,3-1.11L287.2,61.028,285.371,59.2Z",
    transform: "translate(-265 -59.2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46",
    "data-name": "Group 46",
    transform: "translate(10.74 18.51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_422",
    "data-name": "Path 422",
    className: "cls-3",
    d: "M284.455,80.992l-2.22,2.22a3.8,3.8,0,0,1-1.045,3.722,3.954,3.954,0,0,1-3.722,1.045l-2.677,2.677a1.293,1.293,0,0,0,1.828,1.828l9.728-9.663a1.262,1.262,0,0,0,0-1.828A1.34,1.34,0,0,0,284.455,80.992Z",
    transform: "translate(-274.4 -80.6)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_47",
    "data-name": "Group 47",
    transform: "translate(9.826 0.612)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_423",
    "data-name": "Path 423",
    className: "cls-3",
    d: "M282.4,53.587l-4.9,4.9a3.11,3.11,0,0,1-.914,2.742,3.17,3.17,0,0,1-2.742.914l-.457.457a1.293,1.293,0,0,0,1.828,1.828L284.3,55.35a1.262,1.262,0,0,0,0-1.828A1.4,1.4,0,0,0,282.4,53.587Z",
    transform: "translate(-273 -53.187)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_48",
    "data-name": "Group 48",
    transform: "translate(9.173 4.407)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_424",
    "data-name": "Path 424",
    className: "cls-3",
    d: "M275.33,59.588a1.939,1.939,0,1,1-2.742,0A1.893,1.893,0,0,1,275.33,59.588Z",
    transform: "translate(-272 -59)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_50",
    "data-name": "Group 50",
    transform: "translate(2.775 15.572)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49",
    "data-name": "Group 49"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_425",
    "data-name": "Path 425",
    className: "cls-3",
    d: "M268.99,78.32l-4.57,4.57a1.293,1.293,0,1,1-1.828-1.828l4.57-4.57a1.293,1.293,0,1,1,1.828,1.828Z",
    transform: "translate(-262.2 -76.1)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_52",
    "data-name": "Group 52",
    transform: "translate(150.169 57.456)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_426",
    "data-name": "Path 426",
    className: "cls-3",
    d: "M245.017,90.612H231.306a1.306,1.306,0,0,1,0-2.612h13.711a1.306,1.306,0,1,1,0,2.612Z",
    transform: "translate(-230 -88)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_53",
    "data-name": "Group 53",
    transform: "translate(139.723 57.456)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_427",
    "data-name": "Path 427",
    className: "cls-3",
    d: "M219.876,90.612h-4.57a1.306,1.306,0,0,1,0-2.612h4.57a1.306,1.306,0,0,1,0,2.612Z",
    transform: "translate(-214 -88)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_58",
    "data-name": "Group 58",
    transform: "translate(201.749 40.48)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_54",
    "data-name": "Group 54"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_428",
    "data-name": "Path 428",
    className: "cls-3",
    d: "M316.182,64.612h-5.876a1.306,1.306,0,0,1,0-2.612h5.876a1.306,1.306,0,1,1,0,2.612Z",
    transform: "translate(-309 -62)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_55",
    "data-name": "Group 55",
    transform: "translate(11.099)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_429",
    "data-name": "Path 429",
    className: "cls-3",
    d: "M330.57,64.612h-3.265a1.306,1.306,0,0,1,0-2.612h3.265a1.306,1.306,0,0,1,0,2.612Z",
    transform: "translate(-326 -62)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_56",
    "data-name": "Group 56",
    transform: "translate(3.917 10.447)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_430",
    "data-name": "Path 430",
    className: "cls-3",
    d: "M330.017,80.612H316.306a1.306,1.306,0,1,1,0-2.612h13.711a1.306,1.306,0,1,1,0,2.612Z",
    transform: "translate(-315 -78)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_57",
    "data-name": "Group 57",
    transform: "translate(23.505 10.447)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_431",
    "data-name": "Path 431",
    className: "cls-3",
    d: "M348.917,80.612h-2.612a1.306,1.306,0,0,1,0-2.612h2.612a1.306,1.306,0,0,1,0,2.612Z",
    transform: "translate(-345 -78)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63",
    "data-name": "Group 63",
    transform: "translate(233.35 68.294)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_59",
    "data-name": "Group 59",
    transform: "translate(6.268 6.252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_432",
    "data-name": "Path 432",
    className: "cls-3",
    d: "M372.223,124.638a5.4,5.4,0,0,1-3.722-1.5,5.176,5.176,0,0,1-1.5-3.722,5.4,5.4,0,0,1,1.5-3.722,5.241,5.241,0,0,1,7.378,0h0a5.176,5.176,0,0,1,1.5,3.722,5.129,5.129,0,0,1-5.158,5.223Zm0-7.835a2.678,2.678,0,0,0-2.612,2.612,2.371,2.371,0,0,0,.784,1.828,2.724,2.724,0,0,0,3.722,0,2.578,2.578,0,0,0,.783-1.828,2.371,2.371,0,0,0-.783-1.828h0A2.846,2.846,0,0,0,372.223,116.8Z",
    transform: "translate(-367 -114.175)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_60",
    "data-name": "Group 60",
    transform: "translate(0 5.55)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_433",
    "data-name": "Path 433",
    className: "cls-3",
    d: "M366.149,123.09a1.289,1.289,0,0,1-.914-.392l-7.443-7.378a1.293,1.293,0,0,1,1.828-1.828L367,120.87a1.262,1.262,0,0,1,0,1.828A1.053,1.053,0,0,1,366.149,123.09Z",
    transform: "translate(-357.4 -113.1)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61",
    "data-name": "Group 61",
    transform: "translate(5.55)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_434",
    "data-name": "Path 434",
    className: "cls-3",
    d: "M374.584,114.59a1.289,1.289,0,0,1-.914-.392l-7.378-7.378a1.293,1.293,0,0,1,1.828-1.828l7.378,7.378a1.262,1.262,0,0,1,0,1.828A1.1,1.1,0,0,1,374.584,114.59Z",
    transform: "translate(-365.9 -104.6)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_62",
    "data-name": "Group 62"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_435",
    "data-name": "Path 435",
    className: "cls-3",
    d: "M366.149,114.59a1.289,1.289,0,0,1-.914-.392l-7.443-7.378a1.293,1.293,0,0,1,1.828-1.828L367,112.37a1.262,1.262,0,0,1,0,1.828A1.053,1.053,0,0,1,366.149,114.59Z",
    transform: "translate(-357.4 -104.6)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_68",
    "data-name": "Group 68",
    transform: "translate(126.012 23.505)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_64",
    "data-name": "Group 64",
    transform: "translate(3.265)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_436",
    "data-name": "Path 436",
    className: "cls-3",
    d: "M198.653,39.265a.617.617,0,0,1-.653-.653V36.653a.653.653,0,0,1,1.306,0v1.959A.617.617,0,0,1,198.653,39.265Z",
    transform: "translate(-198 -36)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_65",
    "data-name": "Group 65",
    transform: "translate(0 3.265)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_437",
    "data-name": "Path 437",
    className: "cls-3",
    d: "M195.612,42.306h-1.959a.653.653,0,0,1,0-1.306h1.959a.653.653,0,0,1,0,1.306Z",
    transform: "translate(-193 -41)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_66",
    "data-name": "Group 66",
    transform: "translate(3.265 4.57)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_438",
    "data-name": "Path 438",
    className: "cls-3",
    d: "M198.653,46.265a.617.617,0,0,1-.653-.653V43.653a.653.653,0,0,1,1.306,0v1.959A.617.617,0,0,1,198.653,46.265Z",
    transform: "translate(-198 -43)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_67",
    "data-name": "Group 67",
    transform: "translate(4.57 3.265)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_439",
    "data-name": "Path 439",
    className: "cls-3",
    d: "M202.612,42.306h-1.959a.653.653,0,1,1,0-1.306h1.959a.653.653,0,1,1,0,1.306Z",
    transform: "translate(-200 -41)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_73",
    "data-name": "Group 73",
    transform: "translate(10.577 61.569)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69",
    "data-name": "Group 69",
    transform: "translate(2.742 0.065)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_440",
    "data-name": "Path 440",
    className: "cls-3",
    d: "M21.053,96.62a.593.593,0,0,1-.457-.2.631.631,0,0,1,0-.914l.914-.914a.646.646,0,0,1,.914.914l-.914.914A.593.593,0,0,1,21.053,96.62Z",
    transform: "translate(-20.4 -94.4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_70",
    "data-name": "Group 70"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_441",
    "data-name": "Path 441",
    className: "cls-3",
    d: "M17.767,96.585a.593.593,0,0,1-.457-.2L16.4,95.41a.646.646,0,1,1,.914-.914l.914.914a.631.631,0,0,1,0,.914A.566.566,0,0,1,17.767,96.585Z",
    transform: "translate(-16.2 -94.3)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_71",
    "data-name": "Group 71",
    transform: "translate(0 2.808)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_442",
    "data-name": "Path 442",
    className: "cls-3",
    d: "M16.853,100.82a.593.593,0,0,1-.457-.2.631.631,0,0,1,0-.914l.914-.914a.646.646,0,0,1,.914.914l-.914.914A.705.705,0,0,1,16.853,100.82Z",
    transform: "translate(-16.2 -98.6)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_72",
    "data-name": "Group 72",
    transform: "translate(2.742 2.808)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_443",
    "data-name": "Path 443",
    className: "cls-3",
    d: "M21.967,100.82a.593.593,0,0,1-.457-.2L20.6,99.71a.646.646,0,1,1,.914-.914l.914.914a.631.631,0,0,1,0,.914A.593.593,0,0,1,21.967,100.82Z",
    transform: "translate(-20.4 -98.6)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_78",
    "data-name": "Group 78",
    transform: "translate(53.539 43.223)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_74",
    "data-name": "Group 74",
    transform: "translate(3.265 1.959)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_444",
    "data-name": "Path 444",
    className: "cls-3",
    d: "M88.306,70.506h-.653a.653.653,0,0,1,0-1.306h.653a.617.617,0,0,1,.653.653A.654.654,0,0,1,88.306,70.506Z",
    transform: "translate(-87 -69.2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_75",
    "data-name": "Group 75",
    transform: "translate(1.959)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_445",
    "data-name": "Path 445",
    className: "cls-3",
    d: "M85.653,68.159A.617.617,0,0,1,85,67.506v-.653a.653.653,0,0,1,1.306,0v.653A.654.654,0,0,1,85.653,68.159Z",
    transform: "translate(-85 -66.2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_76",
    "data-name": "Group 76",
    transform: "translate(0 1.959)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_446",
    "data-name": "Path 446",
    className: "cls-3",
    d: "M83.306,70.506h-.653a.653.653,0,0,1,0-1.306h.653a.617.617,0,0,1,.653.653A.654.654,0,0,1,83.306,70.506Z",
    transform: "translate(-82 -69.2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_77",
    "data-name": "Group 77",
    transform: "translate(1.959 3.265)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_447",
    "data-name": "Path 447",
    className: "cls-3",
    d: "M85.653,73.159A.617.617,0,0,1,85,72.506v-.653a.653.653,0,1,1,1.306,0v.653A.654.654,0,0,1,85.653,73.159Z",
    transform: "translate(-85 -71.2)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_83",
    "data-name": "Group 83",
    transform: "translate(199.791 76.521)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_79",
    "data-name": "Group 79",
    transform: "translate(1.306)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_615",
    "data-name": "Rectangle 615",
    className: "cls-3",
    width: 1.306,
    height: 1.306
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_80",
    "data-name": "Group 80",
    transform: "translate(0 1.306)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_616",
    "data-name": "Rectangle 616",
    className: "cls-3",
    width: 1.306,
    height: 1.306
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_81",
    "data-name": "Group 81",
    transform: "translate(1.306 2.612)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_617",
    "data-name": "Rectangle 617",
    className: "cls-3",
    width: 1.306,
    height: 1.306
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_82",
    "data-name": "Group 82",
    transform: "translate(2.612 1.306)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_618",
    "data-name": "Rectangle 618",
    className: "cls-3",
    width: 1.306,
    height: 1.306
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_88",
    "data-name": "Group 88",
    transform: "translate(110.342 42.57)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84",
    "data-name": "Group 84"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_448",
    "data-name": "Path 448",
    className: "cls-3",
    d: "M176.835,80.87a7.835,7.835,0,1,1,7.835-7.835A7.858,7.858,0,0,1,176.835,80.87Zm0-13.058a5.223,5.223,0,1,0,5.223,5.223A5.239,5.239,0,0,0,176.835,67.812Z",
    transform: "translate(-169 -65.2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_85",
    "data-name": "Group 85",
    transform: "translate(4.57 3.917)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    className: "cls-3",
    cx: 1.306,
    cy: 1.306,
    r: 1.306
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_86",
    "data-name": "Group 86",
    transform: "translate(11.099 8.488)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    className: "cls-3",
    cx: 1.306,
    cy: 1.306,
    r: 1.306
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_87",
    "data-name": "Group 87",
    transform: "translate(2.677 7.77)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_449",
    "data-name": "Path 449",
    className: "cls-3",
    d: "M177.67,79.385a2.285,2.285,0,1,1-2.285-2.285A2.313,2.313,0,0,1,177.67,79.385Z",
    transform: "translate(-173.1 -77.1)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_89",
    "data-name": "Group 89",
    transform: "translate(79.655 41.264)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_450",
    "data-name": "Path 450",
    className: "cls-3",
    d: "M135.711,65.812H123.306a1.306,1.306,0,0,1,0-2.612h12.405a1.306,1.306,0,0,1,0,2.612Z",
    transform: "translate(-122 -63.2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_90",
    "data-name": "Group 90",
    transform: "translate(71.82 41.264)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_451",
    "data-name": "Path 451",
    className: "cls-3",
    d: "M113.917,65.812h-2.612a1.306,1.306,0,1,1,0-2.612h2.612a1.306,1.306,0,1,1,0,2.612Z",
    transform: "translate(-110 -63.2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_91",
    "data-name": "Group 91",
    transform: "translate(25.464 89.449)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_452",
    "data-name": "Path 452",
    className: "cls-3",
    d: "M68.9,146.794a.71.71,0,0,1-.326-.065,1.3,1.3,0,0,1-.979-1.567,5.074,5.074,0,0,0,.131-1.045,4.557,4.557,0,0,0-8.945-1.241,1.474,1.474,0,0,1-.849.914,1.43,1.43,0,0,1-1.241-.2,3.33,3.33,0,0,0-2.024-.718,3.185,3.185,0,0,0-3.2,2.808,1.28,1.28,0,0,1-1.306,1.11H40.306a1.306,1.306,0,1,1,0-2.612H49.12a5.938,5.938,0,0,1,5.55-3.917,5.206,5.206,0,0,1,2.22.457A7.279,7.279,0,0,1,63.158,137a7.161,7.161,0,0,1,7.182,7.182,6.439,6.439,0,0,1-.2,1.567A1.252,1.252,0,0,1,68.9,146.794Z",
    transform: "translate(-39 -137)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_93",
    "data-name": "Group 93",
    transform: "translate(159.376 86.119)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_92",
    "data-name": "Group 92"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_453",
    "data-name": "Path 453",
    className: "cls-3",
    d: "M314.288,146.982a.71.71,0,0,1-.326-.065,1.3,1.3,0,0,1-.979-1.567,10.786,10.786,0,0,0,.261-1.959,8.874,8.874,0,0,0-6.921-8.618l-1.959-.2a8.829,8.829,0,0,0-7.7,4.636,1.143,1.143,0,0,1-.979.653,1.243,1.243,0,0,1-1.11-.457,6.987,6.987,0,0,0-5.093-2.285,6.81,6.81,0,0,0-6.137,3.787,1.367,1.367,0,0,1-.979.718,1.2,1.2,0,0,1-1.11-.392,2.537,2.537,0,0,0-2.742-.653,1.336,1.336,0,0,1-1.306-.261,4.383,4.383,0,0,0-2.938-1.175l-2.024.392a4.529,4.529,0,0,0-2.416,2.612,1.177,1.177,0,0,1-.784.784,1.316,1.316,0,0,1-1.11-.131,2.947,2.947,0,0,0-1.632-.457,3.233,3.233,0,0,0-3.265,3.265,1.31,1.31,0,0,1-1.306,1.306H245.406a1.306,1.306,0,1,1,0-2.612h15.148a5.886,5.886,0,0,1,5.746-4.57A5.115,5.115,0,0,1,268,140a7.107,7.107,0,0,1,3.4-2.938.392.392,0,0,1,.261-.065l2.285-.457h.261a7.472,7.472,0,0,1,4.244,1.371,5.289,5.289,0,0,1,3.46.522,9.463,9.463,0,0,1,7.639-3.917,9.246,9.246,0,0,1,5.811,2.024,11.533,11.533,0,0,1,9.206-4.636h.131l2.089.2h.131a11.448,11.448,0,0,1,9.075,11.165,12.425,12.425,0,0,1-.326,2.612A1.494,1.494,0,0,1,314.288,146.982Z",
    transform: "translate(-244.1 -131.9)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_94",
    "data-name": "Group 94",
    transform: "translate(160.616 26.116)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    className: "cls-3",
    cx: 1.306,
    cy: 1.306,
    r: 1.306
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_99",
    "data-name": "Group 99",
    transform: "translate(219.378 27.422)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_95",
    "data-name": "Group 95"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_454",
    "data-name": "Path 454",
    className: "cls-3",
    d: "M336.653,48.529a.653.653,0,0,1,0-1.306c4.505,0,4.57-4.375,4.57-4.57a.654.654,0,0,1,.653-.653h0a.617.617,0,0,1,.653.653A5.678,5.678,0,0,1,336.653,48.529Z",
    transform: "translate(-336 -42)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_96",
    "data-name": "Group 96",
    transform: "translate(5.223)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_455",
    "data-name": "Path 455",
    className: "cls-3",
    d: "M349.876,48.529A5.678,5.678,0,0,1,344,42.653a.653.653,0,1,1,1.306,0h0c0,.2.065,4.57,4.57,4.57a.653.653,0,0,1,0,1.306Zm-4.57-5.876Z",
    transform: "translate(-344 -42)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_97",
    "data-name": "Group 97",
    transform: "translate(5.223 5.223)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_456",
    "data-name": "Path 456",
    className: "cls-3",
    d: "M344.653,56.529h0a.617.617,0,0,1-.653-.653A5.678,5.678,0,0,1,349.876,50a.653.653,0,0,1,0,1.306c-4.505,0-4.57,4.375-4.57,4.57A.654.654,0,0,1,344.653,56.529Z",
    transform: "translate(-344 -50)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_98",
    "data-name": "Group 98",
    transform: "translate(0 5.223)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_457",
    "data-name": "Path 457",
    className: "cls-3",
    d: "M341.876,56.529a.617.617,0,0,1-.653-.653h0c0-.2-.065-4.57-4.57-4.57a.653.653,0,0,1,0-1.306,5.678,5.678,0,0,1,5.876,5.876A.617.617,0,0,1,341.876,56.529Z",
    transform: "translate(-336 -50)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_104",
    "data-name": "Group 104",
    transform: "translate(144.293 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_100",
    "data-name": "Group 100"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_458",
    "data-name": "Path 458",
    className: "cls-3",
    d: "M221.653,6.529A.617.617,0,0,1,221,5.876a.617.617,0,0,1,.653-.653c4.505,0,4.57-4.375,4.57-4.57A.654.654,0,0,1,226.876,0h0a.617.617,0,0,1,.653.653A5.678,5.678,0,0,1,221.653,6.529Z",
    transform: "translate(-221)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_101",
    "data-name": "Group 101",
    transform: "translate(5.223)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_459",
    "data-name": "Path 459",
    className: "cls-3",
    d: "M234.876,6.529A5.678,5.678,0,0,1,229,.653a.653.653,0,1,1,1.306,0h0c0,.2.065,4.57,4.57,4.57a.617.617,0,0,1,.653.653A.617.617,0,0,1,234.876,6.529ZM230.306.653Z",
    transform: "translate(-229)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_102",
    "data-name": "Group 102",
    transform: "translate(5.223 5.223)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_460",
    "data-name": "Path 460",
    className: "cls-3",
    d: "M229.653,14.529h0a.617.617,0,0,1-.653-.653A5.678,5.678,0,0,1,234.876,8a.653.653,0,0,1,0,1.306c-4.505,0-4.57,4.375-4.57,4.57A.654.654,0,0,1,229.653,14.529Z",
    transform: "translate(-229 -8)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_103",
    "data-name": "Group 103",
    transform: "translate(0 5.223)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_461",
    "data-name": "Path 461",
    className: "cls-3",
    d: "M226.876,14.529a.617.617,0,0,1-.653-.653h0c0-.2-.065-4.57-4.57-4.57a.653.653,0,0,1,0-1.306,5.678,5.678,0,0,1,5.876,5.876A.617.617,0,0,1,226.876,14.529Z",
    transform: "translate(-221 -8)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_109",
    "data-name": "Group 109",
    transform: "translate(24.811 31.34)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_105",
    "data-name": "Group 105"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_462",
    "data-name": "Path 462",
    className: "cls-3",
    d: "M38.653,54.529a.653.653,0,1,1,0-1.306c4.505,0,4.57-4.375,4.57-4.57A.654.654,0,0,1,43.876,48h0a.617.617,0,0,1,.653.653A5.678,5.678,0,0,1,38.653,54.529Z",
    transform: "translate(-38 -48)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_106",
    "data-name": "Group 106",
    transform: "translate(5.223)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_463",
    "data-name": "Path 463",
    className: "cls-3",
    d: "M51.876,54.529A5.678,5.678,0,0,1,46,48.653a.653.653,0,1,1,1.306,0h0c0,.2.065,4.57,4.57,4.57a.653.653,0,1,1,0,1.306Zm-4.57-5.876Z",
    transform: "translate(-46 -48)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_107",
    "data-name": "Group 107",
    transform: "translate(5.223 5.223)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_464",
    "data-name": "Path 464",
    className: "cls-3",
    d: "M46.653,62.529h0A.617.617,0,0,1,46,61.876,5.678,5.678,0,0,1,51.876,56a.653.653,0,0,1,0,1.306c-4.505,0-4.57,4.375-4.57,4.57A.654.654,0,0,1,46.653,62.529Z",
    transform: "translate(-46 -56)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_108",
    "data-name": "Group 108",
    transform: "translate(0 5.223)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_465",
    "data-name": "Path 465",
    className: "cls-3",
    d: "M43.876,62.529a.617.617,0,0,1-.653-.653h0c0-.2-.065-4.57-4.57-4.57a.653.653,0,1,1,0-1.306,5.678,5.678,0,0,1,5.876,5.876A.617.617,0,0,1,43.876,62.529Z",
    transform: "translate(-38 -56)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_114",
    "data-name": "Group 114",
    transform: "translate(48.968 6.529)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_110",
    "data-name": "Group 110",
    transform: "translate(3.265)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_466",
    "data-name": "Path 466",
    className: "cls-3",
    d: "M80.653,14.57A.617.617,0,0,1,80,13.917V10.653a.653.653,0,0,1,1.306,0v3.265A.617.617,0,0,1,80.653,14.57Z",
    transform: "translate(-80 -10)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_111",
    "data-name": "Group 111",
    transform: "translate(3.265 5.876)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_467",
    "data-name": "Path 467",
    className: "cls-3",
    d: "M80.653,23.57A.617.617,0,0,1,80,22.917V19.653a.653.653,0,1,1,1.306,0v3.265A.617.617,0,0,1,80.653,23.57Z",
    transform: "translate(-80 -19)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_112",
    "data-name": "Group 112",
    transform: "translate(0 4.57)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_468",
    "data-name": "Path 468",
    className: "cls-3",
    d: "M77.612,18.306H75.653a.653.653,0,0,1,0-1.306h1.959a.653.653,0,0,1,0,1.306Z",
    transform: "translate(-75 -17)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_113",
    "data-name": "Group 113",
    transform: "translate(4.57 4.57)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_469",
    "data-name": "Path 469",
    className: "cls-3",
    d: "M84.612,18.306H82.653a.653.653,0,0,1,0-1.306h1.959a.653.653,0,0,1,0,1.306Z",
    transform: "translate(-82 -17)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_115",
    "data-name": "Group 115",
    transform: "translate(80.308 7.835)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_470",
    "data-name": "Path 470",
    className: "cls-3",
    d: "M131.488,28.976a8.488,8.488,0,1,1,8.488-8.488A8.471,8.471,0,0,1,131.488,28.976Zm0-14.364a5.876,5.876,0,1,0,5.876,5.876A5.852,5.852,0,0,0,131.488,14.612Z",
    transform: "translate(-123 -12)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_116",
    "data-name": "Group 116",
    transform: "translate(73.126 0.653)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_471",
    "data-name": "Path 471",
    className: "cls-3",
    d: "M127.67,32.34a15.67,15.67,0,1,1,15.67-15.67A15.716,15.716,0,0,1,127.67,32.34Zm0-28.728A13.058,13.058,0,1,0,140.728,16.67,13.1,13.1,0,0,0,127.67,3.612Z",
    transform: "translate(-112 -1)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_117",
    "data-name": "Group 117",
    transform: "translate(99.242 12.405)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    className: "cls-3",
    cx: 3.917,
    cy: 3.917,
    r: 3.917
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_118",
    "data-name": "Group 118",
    transform: "translate(86.184 9.794)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_472",
    "data-name": "Path 472",
    className: "cls-3",
    d: "M134.938,18.917c-1.7,0-2.938-.849-2.938-1.959S133.241,15,134.938,15s2.938.849,2.938,1.959S136.636,18.917,134.938,18.917Zm0-2.612c-.979,0-1.632.457-1.632.653s.653.653,1.632.653,1.632-.457,1.632-.653S135.917,16.306,134.938,16.306Z",
    transform: "translate(-132 -15)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_119",
    "data-name": "Group 119",
    transform: "translate(82.488 13.417)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_473",
    "data-name": "Path 473",
    className: "cls-3",
    d: "M127.75,25.675h-.261c-.914-.2-1.371-1.436-1.045-2.873a3.856,3.856,0,0,1,.718-1.567,1.4,1.4,0,0,1,1.436-.653h0c.914.2,1.371,1.436,1.045,2.873a3.856,3.856,0,0,1-.718,1.567A1.384,1.384,0,0,1,127.75,25.675Zm.588-3.787a2.339,2.339,0,0,0-.588,1.175,1.939,1.939,0,0,0,.065,1.306,2.339,2.339,0,0,0,.588-1.175A1.939,1.939,0,0,0,128.338,21.888Z",
    transform: "translate(-126.339 -20.549)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_120",
    "data-name": "Group 120",
    transform: "translate(47.01 24.158)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_474",
    "data-name": "Path 474",
    className: "cls-3",
    d: "M88.323,39.612H73.306a1.306,1.306,0,1,1,0-2.612H88.323a1.306,1.306,0,1,1,0,2.612Z",
    transform: "translate(-72 -37)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_121",
    "data-name": "Group 121",
    transform: "translate(38.522 24.158)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_475",
    "data-name": "Path 475",
    className: "cls-3",
    d: "M63.57,39.612H60.306a1.306,1.306,0,0,1,0-2.612H63.57a1.306,1.306,0,1,1,0,2.612Z",
    transform: "translate(-59 -37)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_220",
    "data-name": "Group 220",
    transform: "translate(-21722.039 -1414.211)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_170",
    "data-name": "Group 170"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_124",
    "data-name": "Group 124",
    transform: "translate(0 3.917)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_122",
    "data-name": "Group 122",
    transform: "translate(0 1.959)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_619",
    "data-name": "Rectangle 619",
    className: "cls-2",
    width: 1.306,
    height: 3.265
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_123",
    "data-name": "Group 123",
    transform: "translate(2.612)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_620",
    "data-name": "Rectangle 620",
    className: "cls-2",
    width: 1.306,
    height: 5.223
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_127",
    "data-name": "Group 127",
    transform: "translate(5.223 5.223)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_125",
    "data-name": "Group 125"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_621",
    "data-name": "Rectangle 621",
    className: "cls-2",
    width: 1.306,
    height: 3.917
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_126",
    "data-name": "Group 126",
    transform: "translate(2.612 1.306)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_622",
    "data-name": "Rectangle 622",
    className: "cls-2",
    width: 1.306,
    height: 2.612
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_130",
    "data-name": "Group 130",
    transform: "translate(10.447 1.306)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_128",
    "data-name": "Group 128",
    transform: "translate(0 3.265)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_623",
    "data-name": "Rectangle 623",
    className: "cls-2",
    width: 1.306,
    height: 4.57
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_129",
    "data-name": "Group 129",
    transform: "translate(2.612)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_624",
    "data-name": "Rectangle 624",
    className: "cls-2",
    width: 1.306,
    height: 7.835
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_133",
    "data-name": "Group 133",
    transform: "translate(15.67)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_131",
    "data-name": "Group 131"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_625",
    "data-name": "Rectangle 625",
    className: "cls-2",
    width: 1.306,
    height: 9.141
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_132",
    "data-name": "Group 132",
    transform: "translate(2.612 4.57)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_626",
    "data-name": "Rectangle 626",
    className: "cls-2",
    width: 1.306,
    height: 4.57
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_136",
    "data-name": "Group 136",
    transform: "translate(36.563 2.612)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_134",
    "data-name": "Group 134",
    transform: "translate(2.612 2.612)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_627",
    "data-name": "Rectangle 627",
    className: "cls-2",
    width: 1.306,
    height: 3.917
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_135",
    "data-name": "Group 135"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_628",
    "data-name": "Rectangle 628",
    className: "cls-2",
    width: 1.306,
    height: 6.529
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_139",
    "data-name": "Group 139",
    transform: "translate(31.34 3.917)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_137",
    "data-name": "Group 137",
    transform: "translate(2.612 2.612)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_629",
    "data-name": "Rectangle 629",
    className: "cls-2",
    width: 1.306,
    height: 2.612
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_138",
    "data-name": "Group 138"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_630",
    "data-name": "Rectangle 630",
    className: "cls-2",
    width: 1.306,
    height: 5.223
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_142",
    "data-name": "Group 142",
    transform: "translate(26.116 1.306)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_140",
    "data-name": "Group 140",
    transform: "translate(2.612)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_631",
    "data-name": "Rectangle 631",
    className: "cls-2",
    width: 1.306,
    height: 7.835
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_141",
    "data-name": "Group 141",
    transform: "translate(0 1.959)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_632",
    "data-name": "Rectangle 632",
    className: "cls-2",
    width: 1.306,
    height: 5.876
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_145",
    "data-name": "Group 145",
    transform: "translate(20.893 1.959)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_143",
    "data-name": "Group 143",
    transform: "translate(2.612)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_633",
    "data-name": "Rectangle 633",
    className: "cls-2",
    width: 1.306,
    height: 7.182
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_144",
    "data-name": "Group 144",
    transform: "translate(0 0.653)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_634",
    "data-name": "Rectangle 634",
    className: "cls-2",
    width: 1.306,
    height: 6.529
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_148",
    "data-name": "Group 148",
    transform: "translate(78.349 3.265)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_146",
    "data-name": "Group 146",
    transform: "translate(2.612 1.959)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_635",
    "data-name": "Rectangle 635",
    className: "cls-2",
    width: 1.306,
    height: 3.917
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_147",
    "data-name": "Group 147"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_636",
    "data-name": "Rectangle 636",
    className: "cls-2",
    width: 1.306,
    height: 5.876
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_151",
    "data-name": "Group 151",
    transform: "translate(73.126 5.876)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_149",
    "data-name": "Group 149",
    transform: "translate(2.612 1.306)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_637",
    "data-name": "Rectangle 637",
    className: "cls-2",
    width: 1.306,
    height: 1.959
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_150",
    "data-name": "Group 150"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_638",
    "data-name": "Rectangle 638",
    className: "cls-2",
    width: 1.306,
    height: 3.265
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_154",
    "data-name": "Group 154",
    transform: "translate(67.903 2.612)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_152",
    "data-name": "Group 152",
    transform: "translate(2.612)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_639",
    "data-name": "Rectangle 639",
    className: "cls-2",
    width: 1.306,
    height: 6.529
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_153",
    "data-name": "Group 153",
    transform: "translate(0 0.653)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_640",
    "data-name": "Rectangle 640",
    className: "cls-2",
    width: 1.306,
    height: 5.876
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_157",
    "data-name": "Group 157",
    transform: "translate(62.679 1.959)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155",
    "data-name": "Group 155",
    transform: "translate(2.612)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_641",
    "data-name": "Rectangle 641",
    className: "cls-2",
    width: 1.306,
    height: 7.182
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_156",
    "data-name": "Group 156",
    transform: "translate(0 2.612)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_642",
    "data-name": "Rectangle 642",
    className: "cls-2",
    width: 1.306,
    height: 4.57
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_160",
    "data-name": "Group 160",
    transform: "translate(41.786 2.612)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_158",
    "data-name": "Group 158",
    transform: "translate(0 2.612)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_643",
    "data-name": "Rectangle 643",
    className: "cls-2",
    width: 1.306,
    height: 3.917
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_159",
    "data-name": "Group 159",
    transform: "translate(2.612)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_644",
    "data-name": "Rectangle 644",
    className: "cls-2",
    width: 1.306,
    height: 6.529
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_163",
    "data-name": "Group 163",
    transform: "translate(47.01 1.959)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_161",
    "data-name": "Group 161",
    transform: "translate(0 3.265)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_645",
    "data-name": "Rectangle 645",
    className: "cls-2",
    width: 1.306,
    height: 3.917
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_162",
    "data-name": "Group 162",
    transform: "translate(2.612)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_646",
    "data-name": "Rectangle 646",
    className: "cls-2",
    width: 1.306,
    height: 7.182
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_166",
    "data-name": "Group 166",
    transform: "translate(52.233 0.653)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_164",
    "data-name": "Group 164",
    transform: "translate(0 2.612)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_647",
    "data-name": "Rectangle 647",
    className: "cls-2",
    width: 1.306,
    height: 5.876
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_165",
    "data-name": "Group 165",
    transform: "translate(2.612)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_648",
    "data-name": "Rectangle 648",
    className: "cls-2",
    width: 1.306,
    height: 8.488
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_169",
    "data-name": "Group 169",
    transform: "translate(57.456 2.612)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_167",
    "data-name": "Group 167",
    transform: "translate(0 1.306)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_649",
    "data-name": "Rectangle 649",
    className: "cls-2",
    width: 1.306,
    height: 5.223
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_168",
    "data-name": "Group 168",
    transform: "translate(2.612)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_650",
    "data-name": "Rectangle 650",
    className: "cls-2",
    width: 1.306,
    height: 6.529
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_219",
    "data-name": "Group 219",
    transform: "translate(1.306)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_173",
    "data-name": "Group 173",
    transform: "translate(78.349 3.917)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_171",
    "data-name": "Group 171",
    transform: "translate(2.612 1.959)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_651",
    "data-name": "Rectangle 651",
    className: "cls-2",
    width: 1.306,
    height: 3.265
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_172",
    "data-name": "Group 172"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_652",
    "data-name": "Rectangle 652",
    className: "cls-2",
    width: 1.306,
    height: 5.223
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_176",
    "data-name": "Group 176",
    transform: "translate(73.126 5.223)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_174",
    "data-name": "Group 174",
    transform: "translate(2.612)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_653",
    "data-name": "Rectangle 653",
    className: "cls-2",
    width: 1.306,
    height: 3.917
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_175",
    "data-name": "Group 175",
    transform: "translate(0 1.306)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_654",
    "data-name": "Rectangle 654",
    className: "cls-2",
    width: 1.306,
    height: 2.612
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_179",
    "data-name": "Group 179",
    transform: "translate(67.903 1.306)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_177",
    "data-name": "Group 177",
    transform: "translate(2.612 3.265)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_655",
    "data-name": "Rectangle 655",
    className: "cls-2",
    width: 1.306,
    height: 4.57
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_178",
    "data-name": "Group 178"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_656",
    "data-name": "Rectangle 656",
    className: "cls-2",
    width: 1.306,
    height: 7.835
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_182",
    "data-name": "Group 182",
    transform: "translate(62.679)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_180",
    "data-name": "Group 180",
    transform: "translate(2.612)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_657",
    "data-name": "Rectangle 657",
    className: "cls-2",
    width: 1.306,
    height: 9.141
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_181",
    "data-name": "Group 181",
    transform: "translate(0 4.57)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_658",
    "data-name": "Rectangle 658",
    className: "cls-2",
    width: 1.306,
    height: 4.57
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_185",
    "data-name": "Group 185",
    transform: "translate(41.786 2.612)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_183",
    "data-name": "Group 183",
    transform: "translate(0 2.612)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_659",
    "data-name": "Rectangle 659",
    className: "cls-2",
    width: 1.306,
    height: 3.917
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_184",
    "data-name": "Group 184",
    transform: "translate(2.612)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_660",
    "data-name": "Rectangle 660",
    className: "cls-2",
    width: 1.306,
    height: 6.529
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_188",
    "data-name": "Group 188",
    transform: "translate(47.01 3.917)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_186",
    "data-name": "Group 186",
    transform: "translate(0 2.612)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_661",
    "data-name": "Rectangle 661",
    className: "cls-2",
    width: 1.306,
    height: 2.612
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_187",
    "data-name": "Group 187",
    transform: "translate(2.612)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_662",
    "data-name": "Rectangle 662",
    className: "cls-2",
    width: 1.306,
    height: 5.223
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_191",
    "data-name": "Group 191",
    transform: "translate(52.233 1.306)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_189",
    "data-name": "Group 189"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_663",
    "data-name": "Rectangle 663",
    className: "cls-2",
    width: 1.306,
    height: 7.835
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_190",
    "data-name": "Group 190",
    transform: "translate(2.612 1.959)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_664",
    "data-name": "Rectangle 664",
    className: "cls-2",
    width: 1.306,
    height: 5.876
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_194",
    "data-name": "Group 194",
    transform: "translate(57.456 1.959)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_192",
    "data-name": "Group 192"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_665",
    "data-name": "Rectangle 665",
    className: "cls-2",
    width: 1.306,
    height: 7.182
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_193",
    "data-name": "Group 193",
    transform: "translate(2.612 0.653)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_666",
    "data-name": "Rectangle 666",
    className: "cls-2",
    width: 1.306,
    height: 6.529
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_197",
    "data-name": "Group 197",
    transform: "translate(0 3.265)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_195",
    "data-name": "Group 195",
    transform: "translate(0 1.959)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_667",
    "data-name": "Rectangle 667",
    className: "cls-2",
    width: 1.306,
    height: 3.917
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_196",
    "data-name": "Group 196",
    transform: "translate(2.612)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_668",
    "data-name": "Rectangle 668",
    className: "cls-2",
    width: 1.306,
    height: 5.876
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_200",
    "data-name": "Group 200",
    transform: "translate(5.223 5.876)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_198",
    "data-name": "Group 198",
    transform: "translate(0 1.306)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_669",
    "data-name": "Rectangle 669",
    className: "cls-2",
    width: 1.306,
    height: 1.959
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_199",
    "data-name": "Group 199",
    transform: "translate(2.612)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_670",
    "data-name": "Rectangle 670",
    className: "cls-2",
    width: 1.306,
    height: 3.265
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_203",
    "data-name": "Group 203",
    transform: "translate(10.447 2.612)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_201",
    "data-name": "Group 201"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_671",
    "data-name": "Rectangle 671",
    className: "cls-2",
    width: 1.306,
    height: 6.529
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_202",
    "data-name": "Group 202",
    transform: "translate(2.612 0.653)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_672",
    "data-name": "Rectangle 672",
    className: "cls-2",
    width: 1.306,
    height: 5.876
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_206",
    "data-name": "Group 206",
    transform: "translate(15.67 1.959)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_204",
    "data-name": "Group 204"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_673",
    "data-name": "Rectangle 673",
    className: "cls-2",
    width: 1.306,
    height: 7.182
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_205",
    "data-name": "Group 205",
    transform: "translate(2.612 2.612)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_674",
    "data-name": "Rectangle 674",
    className: "cls-2",
    width: 1.306,
    height: 4.57
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_209",
    "data-name": "Group 209",
    transform: "translate(36.563 2.612)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_207",
    "data-name": "Group 207",
    transform: "translate(2.612 2.612)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_675",
    "data-name": "Rectangle 675",
    className: "cls-2",
    width: 1.306,
    height: 3.917
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_208",
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_676",
    "data-name": "Rectangle 676",
    className: "cls-2",
    width: 1.306,
    height: 6.529
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_212",
    "data-name": "Group 212",
    transform: "translate(31.34 1.959)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_210",
    "data-name": "Group 210",
    transform: "translate(2.612 3.265)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_677",
    "data-name": "Rectangle 677",
    className: "cls-2",
    width: 1.306,
    height: 3.917
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_211",
    "data-name": "Group 211"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_678",
    "data-name": "Rectangle 678",
    className: "cls-2",
    width: 1.306,
    height: 7.182
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_215",
    "data-name": "Group 215",
    transform: "translate(26.116 0.653)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_213",
    "data-name": "Group 213",
    transform: "translate(2.612 2.612)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_679",
    "data-name": "Rectangle 679",
    className: "cls-2",
    width: 1.306,
    height: 5.876
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_214",
    "data-name": "Group 214"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_680",
    "data-name": "Rectangle 680",
    className: "cls-2",
    width: 1.306,
    height: 8.488
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_218",
    "data-name": "Group 218",
    transform: "translate(20.893 2.612)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_216",
    "data-name": "Group 216",
    transform: "translate(2.612 1.306)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_681",
    "data-name": "Rectangle 681",
    className: "cls-2",
    width: 1.306,
    height: 5.223
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_217",
    "data-name": "Group 217"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_682",
    "data-name": "Rectangle 682",
    className: "cls-2",
    width: 1.306,
    height: 6.529
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_227",
    "data-name": "Group 227",
    transform: "translate(-21758.602 -1406.376)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_222",
    "data-name": "Group 222",
    transform: "translate(18.934)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_221",
    "data-name": "Group 221"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_476",
    "data-name": "Path 476",
    className: "cls-2",
    d: "M213.871,199.612H98.306a1.306,1.306,0,1,1,0-2.612H213.871a1.306,1.306,0,0,1,0,2.612Z",
    transform: "translate(-97 -197)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_223",
    "data-name": "Group 223",
    transform: "translate(9.141)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_477",
    "data-name": "Path 477",
    className: "cls-2",
    d: "M87.223,199.612H83.306a1.306,1.306,0,0,1,0-2.612h3.917a1.306,1.306,0,0,1,0,2.612Z",
    transform: "translate(-82 -197)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_224",
    "data-name": "Group 224"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_478",
    "data-name": "Path 478",
    className: "cls-2",
    d: "M73.223,199.612H69.306a1.306,1.306,0,1,1,0-2.612h3.917a1.306,1.306,0,0,1,0,2.612Z",
    transform: "translate(-68 -197)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_225",
    "data-name": "Group 225",
    transform: "translate(148.864)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_479",
    "data-name": "Path 479",
    className: "cls-2",
    d: "M301.223,199.612h-3.917a1.306,1.306,0,0,1,0-2.612h3.917a1.306,1.306,0,0,1,0,2.612Z",
    transform: "translate(-296 -197)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_226",
    "data-name": "Group 226",
    transform: "translate(139.723)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_480",
    "data-name": "Path 480",
    className: "cls-2",
    d: "M287.223,199.612h-3.917a1.306,1.306,0,0,1,0-2.612h3.917a1.306,1.306,0,0,1,0,2.612Z",
    transform: "translate(-282 -197)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScope);
export default __webpack_public_path__ + "static/media/scope.45be0248b9a13f17e9a5bd400bdf873f.svg";
export { ForwardRef as ReactComponent };